


window.$ = window.jQuery = require('jquery');
require('bootstrap');

import  './barba/barba';
